export default class FlexiComboProductGiftModel {
    constructor() {
        this.flexiComboId = 0;
        this.productVariantId = 0;
        this.productVariantName = "";
    }
}
